import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import Top_Causes_list_One from "../../assests/images/top-causes-images/top_causes_list_one.webp";
import Top_Causes_list_Two from "../../assests/images/top-causes-images/top_causes_list_two.webp";
import Top_Causes_list_Three from "../../assests/images/top-causes-images/top_causes_list_three.webp";
import Top_Causes_list_Four from "../../assests/images/top-causes-images/top_causes_list_four.webp";
import Top_Causes_list_Five from "../../assests/images/top-causes-images/top_causes_list_five.webp";
import Top_Causes_list_Six from "../../assests/images/top-causes-images/top_causes_list_six.webp";
import {
    TopCausesSection,
    TopCausesListSection,
    TopCausesImageBox,
    TopCausesBannerWrap,
    CausesListBox,
} from "./causesStyle";
import { Title, WriteReviewSection, ReviewText, ReviewRightSection, RightBanner } from "../../components/common/commonSubBanner/commonSubBannerStyle";
import ReviewImage from "../../assests/images/top-banner-image/top-causes-img.webp";
import { CitiesBox, CitiesBoxSubTitle, CityNameList } from "../../components/common/issueGrid/issueGridStyle";
import { useNavigate } from "react-router-dom";
import { topCausesHandler } from "../../redux/slices/donationCamp/topCauses-slice";
import { useDispatch, useSelector } from "react-redux";
import { TopCauseProps } from "../../utils/types";
import SimpleLoader from "../../components/common/simpleLoader/Loader";
import MetaComponent from "../../components/common/metaComponent";

const TopCauses = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const topCausesData = useSelector((state: TopCauseProps) => state?.topCauses?.data?.results);
    const [loader,setLoader] = useState(false);

        useEffect(()=>{
            setLoader(false);
        },[topCausesData])

    useEffect(() => {
        dispatch(topCausesHandler() as any);
        setLoader(true)
    }, [dispatch]);

    const images = [{
            id: 1,
            src: Top_Causes_list_One,
            alt: "top causes list One"
        }, {
            id: 2,
            src: Top_Causes_list_Two,
            alt: "top causes list Two"
        }, {
            id: 3,
            src: Top_Causes_list_Three,
            alt: "Top Causes list Three"
        }, {
            id: 4,
            src: Top_Causes_list_Four,
            alt: "top causes list Four"
        }, {
            id: 5,
            src: Top_Causes_list_Five,
            alt: "top causes list Five"
        }, {
            id: 6,
            src: Top_Causes_list_Six,
            alt: "Top Causes list Six"
        },{
            id: 7,
            src: Top_Causes_list_Six,
            alt: "Top Causes list Six"
        }
    ];

    return (
        <>
        <MetaComponent 
            keywords=""
            description=""
            ogTitle="Top Categories and Causes | aboutgreatnonprofits"
            ogDescription=""
            ogUrl="https://www.about.greatnonprofits.org/categories-and-causes"
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />

            <TopCausesBannerWrap>
                <TopCausesSection>
                    <WriteReviewSection className="top-causes-banner">
                        <Container className="cont-w">
                            <Row>
                                <Col lg={6} sm={12} md={12}>
                                    <Title className="page-main-heading">Find Nonprofits & Charities by Popular Categories & Causes</Title>
                                    <ReviewText className="review-content-p">Want to donate to or volunteer for a charity or nonprofit? Find top-rated nonprofits and charities, see ratings and reviews, and start volunteering or donating today. </ReviewText>
                                    <ReviewText className="review-content-p">Browse nonprofits and charities by <Button onClick={() => navigate("/navigation/issues")}> category and cause.</Button> Or search for nonprofits and charities by <Button onClick={() => navigate("/about/cities")}> state.</Button></ReviewText>
                                </Col>
                                <Col lg={6} sm={12} md={12}>
                                    <RightBanner className="left_banner">
                                        <ReviewRightSection>
                                            <Image src={ReviewImage} alt="ReviewImage" />
                                        </ReviewRightSection>
                                    </RightBanner>
                                </Col>
                            </Row>
                        </Container>
                    </WriteReviewSection>
                </TopCausesSection>
            </TopCausesBannerWrap>

            <TopCausesListSection>
                <Container className="cont-w">
                    <Row>
                    {loader?<div className="loader-cities"><SimpleLoader/></div>:
                        <Col lg="12" sm="12" className="top-causes-count">
                            {topCausesData?.map((topCause, index) => (
                                <React.Fragment key={index+1}>
                                    <CausesListBox className="top-causes-list-box">
                                        <CitiesBox>
                                            <CitiesBoxSubTitle onClick={() => navigate(`/categories/view/${topCause?.category?.slug}`)}>
                                                {topCause?.category?.name}
                                            </CitiesBoxSubTitle>
                                            {topCause?.nonprofits?.map((nonprofit, index:number) => (
                                                <CityNameList className="causes-name-list" key={index+1} onClick={() => navigate(`/org/${nonprofit?.slug}`)}>
                                                    {nonprofit?.title}
                                                </CityNameList>
                                            ))}
                                        </CitiesBox>
                                    </CausesListBox>
                                    {(index + 1) % 5 === 0 && images[(index + 1) / 5 - 1] && (
                                        <TopCausesImageBox key={`image-${index+1}`}>
                                            <Image src={images[(index + 1) / 5 - 1].src} alt={images[(index + 1) / 5 - 1].alt} />
                                        </TopCausesImageBox>
                                    )}
                                </React.Fragment>
                            ))}
                        </Col>}
                    </Row>
                </Container>
            </TopCausesListSection>
        </>
        
    );
};

export default TopCauses;
